import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import KH_Image from "../../Images/kh_image_2-1.png";
import kleenhub_logo from "../../Images/plain_logo.png";
import { Button, TextField } from '@mui/material';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { LoadingComponent } from '../../components/LoadingComponent';
import { loginUser, registerUser } from '../../Services/Events.services';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
const webSiteUrl = 'https://kleenhub.com';

export const Login = () => {
    const history = useNavigate();
    const [flag, setFlag] = React.useState(true);
    const [spinnerList, setSpinnerList] = React.useState(false);
    const [phoneNumber, setphoneNumber] = React.useState('');
    const [num, setNum] = React.useState();

    const handleChange = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
          setNum(e.target.value);
        }
    };

    const onRegisterSuccess = async() => {
        try {
            setSpinnerList(true);
            if (phoneNumber && num) {
                if (num.length !== 4 || !phoneNumber) {
                    swal('Error', 'Phone number & passcode are required.', 'error');
                } else {
                    const response = await registerUser({
                        phoneNumber: `+${phoneNumber}`,
                        password: num,
                        register: false,
                    });
                    if (response.status === 200 || response.status === 201) {
                        const data = await response?.data;
                        if (data) {
                            localStorage.setItem("token", data.accessToken);
                            localStorage.setItem("username", data.username);
                            localStorage.setItem("phone", data.phoneNumber);
                            history("/home");
                        }
                    }
                }
            }
            setSpinnerList(false);
        } catch (err) {
            setSpinnerList(false)
            swal('Error', err.response.data.message, 'error');
        }
    }

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Login';  
        const token = localStorage.getItem("token");
        const phone = localStorage.getItem("phone");
        if (token && phone) {
            history("/home");
        }
    }, []);

    const onButtonClick = () => {
        setFlag(!flag)
    }

    const redirectToForgot = () => {
        history(`/forgot-pin`);
    }

    const gotoWebsite = () => {
        window.location.href = webSiteUrl;
    }

    const LoginPage = () => {
        return (
            <LoadingComponent loader={spinnerList}>
                <div style={{ maxWidth: '420px', position: 'absolute',
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                    <div className="img1" style={{ position: 'relative', top: '-100px' }} id="first-page">
                        <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={KH_Image}/>
                        <div className='div-text'>
                            <div id="oval_parent" className="multi-ellipse" style={{ top: '-160px', display: 'block' }}>
                                <div id="oval"></div>
                            </div>
                            <div className="vertical-center" style={{ display: 'block', top: '130px' }}>
                                <p className='text-content-left' style={{ position: 'relative', marginTop: '-190px', textAlign: 'center', padding: '0px' }}>
                                    Welcome to kleenhub.
                                </p>
                                <PhoneInput
                                    country={"dk"}
                                    enableSearch={true}
                                    value={phoneNumber}
                                    onChange={(phone) => setphoneNumber(phone)}
                                    />
                                <TextField id="code" margin="normal" color="success"
                                    label="Enter 4 digit pin" variant="outlined"
                                    inputProps={{ maxLength: 4, style: { textAlign: "center" } }}
                                    InputLabelProps={{
                                        style: { textAlign: 'center'},
                                    }}
                                    style={{ width: '300px' }}
                                    onChange={(e) => handleChange(e)}
                                />
                                <a href="#" onClick={() => redirectToForgot()} style={{ color: '#538103', textDecoration: 'underline', display: 'block', textAlign: 'center' }}>
                                    <strong>
                                    Forgot your PIN ?
                                    </strong>
                                </a>
                                <Button variant="outlined"
                                    style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '25%', top: '25px', lineHeight: '1', width: "160px", height: "68px",
                                    fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                    textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                    disableRipple={true}
                                    onClick={onRegisterSuccess}
                                    >
                                        continue
                                </Button>
                                {/* <Button
                                    style={{ backgroundColor: 'transparent', left: '22%', top: '120px', lineHeight: '1', width: "160px", height: "68px",
                                    fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                    textTransform: "none", color: '#538103' }}
                                    disableRipple={true}
                                    onClick={onButtonClick}
                                    >
                                        tell me more
                                </Button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </LoadingComponent>
        )
    }

    const successPage2 = () => {
        return (
            <LoadingComponent loader={spinnerList}>
                <div style={{ maxWidth: '420px', position: 'absolute',
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <div className='linearGradient'/>
                    <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                    <div className="vertical-center" style={{ display: 'block', width: '100%', top: '230px', position: 'relative' }}>
                        <p className='text-content-left' style={{ position: 'relative', marginTop: '-90px', textAlign: 'center', padding: '0px' }}>
                            How it works
                        </p>
                        <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '25px' }}>          
                            Welcome to the reuse revolution!<br/><br/>
                            You've now joined an incredible community committed to abandoning single-use and embracing reusable packaging to support our planet.<br/><br/>
                            Once you've enjoyed your take-away in kleen hub's reusable packaging, simply return it to one of our affiliated partners.<br/><br/>
                            Scan the QR code on the packaging to find out where to return it and the remaining time you have to do so.<br/><br/>
                        </p>
                        <Button variant="outlined"
                            style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '30%', top: '10px', lineHeight: '1', width: "160px", height: "68px",
                            fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                            textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                            disableRipple={true}
                            onClick={gotoWebsite}
                            >
                                our website
                        </Button>
                    </div>
                </div>
            </LoadingComponent>
        )
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                flag ? LoginPage() : successPage2()
            }
        </div>
    )
}
